import { SanityFootnotes } from '../../types/generated/graphql-types'
import { FootnotesProps } from '../components/blocks/Footnotes'
import { notEmpty } from '../utilities/filters'

export const mapSanityFootnotesToFootnotesProps = ({
  footnotes,
  title,
}: SanityFootnotes): FootnotesProps => ({
  footnotes: footnotes?.filter(notEmpty) ?? [],
  title: title ?? undefined,
})
